const title = "Successfully added"
const copy = "Need the same customisations on another window?"
const addWindow = "Add another window"
const noThanks = "No thanks"
const noThanksCart = "No thanks, go to cart"
const notThanksShopping = "No thanks, continue shopping"

const getCartSuccess = () => {
  const template = document.createElement('template');
  template.innerHTML = `
    <style>

      :host {
        display: block;
      }

      .o-modal {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 70;
        display: block;
        pointer-events: none;
      }

      .o-modal.is-open {
        pointer-events: all;
      }

      .o-modal__close {
        position: absolute;
        top: -1rem;
        right: 1.25rem;
        display: flex;
        width: 2.5rem;
        height: 2.5rem;
        padding: .625rem;
        justify-content: center;
        align-items: center;
        background: white;
        cursor: pointer;
        border-radius: 50%;
        z-index: 2;
        border: none;
      }

      .o-modal__close svg {
        width: 100%;
      }

      .o-modal__inner {
        background: #F5F2F0;
        padding: 40px 20px;
        border-radius: 2rem 2rem 0 0;
        height: 100%;
        overflow-y: auto;
        display: flex;
        align-items: center;
        scrollbar-width: none;
      }

      .o-modal__inner-center {
        text-align: center;
        width: 100%;
        transition: all 500ms;
      }

      .o-modal__inner img {
        margin: 0 33px 0;
        width: calc(100% - 66px);
        border-radius: 20px;
      }

      .o-modal__inner::-webkit-scrollbar {
        display: none;
      }

      .o-modal__inner-wrapper {
        position: absolute;
        top: 4.5rem;
        bottom: 0;
        width: 100%;
        z-index: 1;
        transition: transform 1.4s cubic-bezier(0.16, 1, 0.3, 1);
        transform: translateY(120vh);
      }

      .is-open .o-modal__inner-wrapper {
        transform: translateY(0);
      }

      .o-modal__title {
        margin: 0 0 1.5rem;
      }

      .is-text-center .o-modal__title {
        text-align: center;
      }

      .o-modal__overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        cursor: pointer;
        background: #3f73554d;
        transition: opacity 1.4s cubic-bezier(.16,1,.3,1);
        opacity: 0;
      }

      .is-open .o-modal__overlay {
        opacity: 1;
      }

      .o-modal__inner h5 {
        margin-top: 0;
        font-family: Recoleta, sans-serif;
        font-weight: 500;
        letter-spacing: 0;
        font-size: 1.375rem;
        line-height: 1.75rem;
        margin: 0 0 .625rem;
      }

      .o-modal__inner p {
        font-family: TTNorms Font, Helvectica, sans-serif;
        font-size: .875rem;
        line-height: 1.25rem;
        letter-spacing: .0175rem;
        margin: 0 0 1.875rem;
        font-weight: 500;
      }

      .is-blank-paragraph {
        display: none;
      }

      .o-btn {
        padding: 1rem 1.5rem;
        background: #3F7355;
        outline: none;
        border: none;
        text-align: center;
        border-radius: 1rem;
        font-size: .875rem;
        font-weight: 500;
        line-height: 1.25rem;
        letter-spacing: .0175rem;
        color: #FCFCFB;
        display: block;
        margin: 1.875rem auto 1.5rem;
        width: 100%;
        max-width: 25rem;
        cursor: pointer;
        font-family: "TTNorms Font", sans-serif;
      }

      .tooltip-button {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        padding: .5rem 1rem;
        margin: 1rem auto 0;
        font-size: .875rem;
        font-family: 'TTNorms Font', Helvectica, sans-serif;
        border-radius: .625rem;
        border: none;
        cursor: pointer;
        background-color: #F1EBE7;
        color: inherit;
        text-decoration: none;
      }

      .tooltip-button + .tooltip-button {
        margin-top: 1.25rem;
      }

      .tooltip-button svg {
        width: 1rem;
        height: 1rem;
        margin-left: .375rem;
      }

      .preloader-container {
        opacity: 0;
        pointer-events: none;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        transition: all 500ms;
      }

      .preloader {
        position: relative;
        width: 64px;
        height: 64px;
        background: #D1E6C7;
        border-radius: 50%;
      }

      .ring {
        position: absolute;
        width: calc(100% - 6px);
        height: calc(100% - 6px);
        border-radius: 50%;
        border: 3px solid #D1E6C7;
        border-top-color: #3F7355;
        animation: spin 2s linear infinite;
      }

      .center-icon {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 22px;
        height: 22px;
      }

      .preloader-text {
        font-family: Recoleta,sans-serif;
        font-size: 22px;
        font-style: normal;
        font-weight: 500;
        line-height: 28px;
        margin-top: 2rem;
      }

      .is-adding .preloader-container {
        opacity: 1;
        pointer-events: all;
      }

      .is-adding .o-modal__inner-center {
        opacity: 0;
        pointer-events: none;
      }

      @keyframes spin {
        0% { transform: rotate(0deg); }
        50% { transform: rotate(180deg); }
        100% { transform: rotate(360deg); }
      }

      @media only screen and (min-width: 1100px) {

        .o-btn {
          padding: 1.125rem 2rem;
          font-size: 1rem;
          font-style: normal;
          font-weight: 500;
          line-height: 1.5rem;
          letter-spacing: .02rem;
          transition: all 300ms;
          margin: 2.5rem auto 1.5rem;
        }

        .o-btn:hover {
          border-color: #f5f2f0;
          color: #163021;
          background-color: #fcfcfb;
        }

        .tooltip-button {
          font-size: 1rem;
          font-style: normal;
          font-weight: 400;
          line-height: 1.5rem;
          transition: all 300ms;
        }

        .tooltip-button:hover {
          background-color: #fff;
        }

        .tooltip-button svg {
          width: 18px;
          height: 18px;
        }

        .o-modal__inner {
          border-radius: 2.25rem;
          padding: 3.25rem 2.5rem 2.5rem;
          height: calc(100vh - 10.5rem);
        }

        .o-modal__inner-wrapper {
          top: 2.5rem;
          right: 2.5rem;
          height: calc(100vh - 5rem);
          width: 29.375rem;
          bottom: unset;
          transform: translate(120%);
        }

        .o-modal__inner img {
          margin: 0 40px;
          width: calc(100vh - 80px);
          border-radius: 24px;
        }

        .is-open .o-modal__inner-wrapper {
          transform: translate(0);
        }

        .o-modal__inner h5 {
          font-size: 2rem;
          line-height: 2.5rem;
          margin-bottom: 1rem;
        }

        .o-modal__inner p {
          font-size: 1rem;
          line-height: 1.5rem;
          letter-spacing: .02rem;
          margin: 0 0 2.5rem;
        }

        .preloader-text {
          font-size: 2rem;
          line-height: 2.5rem;
          margin-top: 2.5rem;
        }
      }

      @media only screen and (min-width: 1750px) {

        .o-modal__inner {
          padding: 4rem 3rem 3rem;
          height: calc(100vh - 13rem);
        }

        .o-modal__inner-wrapper {
          top: 3rem;
          right: 3rem;
          width: 38.5rem;
          height: calc(100vh - 6rem);
        }

        .o-modal__inner h5 {
          font-size: 2.5rem;
          line-height: 3rem;
        }

        .o-modal__inner p {
          font-size: 1.25rem;
          line-height: 1.75rem;
        }

        .o-btn {
          letter-spacing: $s-font--letter-default;
          font-size: 1.25rem;
          line-height: 1.75rem;
          margin: 2.5rem auto 2rem;
        }

        .tooltip-button {
          font-size: 1.125rem;
          line-height: 1.5rem;
        }

        .tooltip-button svg {
          width: 1.25rem;
          height: 1.25rem;
        }

        .preloader-text {
          font-size: 2.5rem;
          line-height: 3rem;
        }
      }
    }
    </style>

    <div class="o-modal is-adding" data-cart-success>
    <div class="o-modal__inner-wrapper">
      <div class="o-modal__inner">

        <div class="preloader-container">
          <div class="preloader">
            <div class="ring"></div>
            <span class="center-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M6.66667 5.83333C6.66667 3.99238 8.15906 2.5 10 2.5C11.841 2.5 13.3333 3.99238 13.3333 5.83333" stroke="#3F7355" stroke-width="1.5"/>
                <path d="M2.73145 8.71361C2.65108 7.71351 2.6109 7.21347 2.78084 6.82786C2.93016 6.48905 3.18805 6.20961 3.51381 6.03363C3.88457 5.83334 4.38623 5.83334 5.38954 5.83334H14.6104C15.6138 5.83334 16.1154 5.83334 16.4862 6.03363C16.8119 6.20961 17.0698 6.48905 17.2191 6.82786C17.3891 7.21347 17.3489 7.71351 17.2685 8.71361L16.9567 12.5939C16.8177 14.3241 16.7482 15.1892 16.3667 15.8442C16.0308 16.421 15.5295 16.8836 14.9277 17.1722C14.2443 17.5 13.3764 17.5 11.6405 17.5H8.35945C6.62364 17.5 5.75574 17.5 5.07229 17.1722C4.47048 16.8836 3.96917 16.421 3.63327 15.8442C3.25181 15.1892 3.18229 14.3241 3.04325 12.5939L2.73145 8.71361Z" stroke="#3F7355" stroke-width="1.5"/>
              </svg>
            </span>
          </div>
          <div class="preloader-text">Adding</div>
        </div>

        <div class="o-modal__inner-center">
          <h5>${title}</h5>
          <p>${copy}</p>
          <button class="o-btn" data-add-another>
            ${addWindow}
          </button>
          <a href="/cart" class="tooltip-button">
            <span>${noThanksCart}</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M6.66663 5.83333C6.66663 3.99238 8.15901 2.5 9.99996 2.5C11.8409 2.5 13.3333 3.99238 13.3333 5.83333" stroke="currentColor"/>
              <path d="M2.73143 8.71361C2.65107 7.71351 2.61088 7.21347 2.78083 6.82786C2.93015 6.48905 3.18804 6.20961 3.5138 6.03363C3.88455 5.83334 4.38621 5.83334 5.38953 5.83334H14.6104C15.6138 5.83334 16.1154 5.83334 16.4862 6.03363C16.8119 6.20961 17.0698 6.48905 17.2191 6.82786C17.3891 7.21347 17.3489 7.71351 17.2685 8.71361L16.9567 12.5939C16.8177 14.3241 16.7482 15.1892 16.3667 15.8442C16.0308 16.421 15.5295 16.8836 14.9277 17.1722C14.2442 17.5 13.3763 17.5 11.6405 17.5H8.35944C6.62363 17.5 5.75572 17.5 5.07228 17.1722C4.47046 16.8836 3.96915 16.421 3.63325 15.8442C3.25179 15.1892 3.18227 14.3241 3.04324 12.5939L2.73143 8.71361Z" stroke="currentColor"/>
            </svg>
          </a>
          <a href="/" class="tooltip-button" data-continue-shopping>
            <span>${notThanksShopping}</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
              <g>
                <path d="M4.25 10.9055V15.875C4.25 16.4273 4.69772 16.875 5.25 16.875H15.75C16.3023 16.875 16.75 16.4273 16.75 15.875V10.9055" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M4.71875 3.125H16.2812C16.417 3.12503 16.5491 3.16926 16.6575 3.25101C16.7659 3.33277 16.8447 3.44759 16.882 3.57812L18 7.5H3L4.12031 3.57812C4.15754 3.44798 4.23601 3.33343 4.34393 3.25172C4.45185 3.17 4.58338 3.12553 4.71875 3.125Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M8 7.5V8.75C8 9.41304 7.73661 10.0489 7.26777 10.5178C6.79893 10.9866 6.16304 11.25 5.5 11.25C4.83696 11.25 4.20107 10.9866 3.73223 10.5178C3.26339 10.0489 3 9.41304 3 8.75V7.5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M13 7.5V8.75C13 9.41304 12.7366 10.0489 12.2678 10.5178C11.7989 10.9866 11.163 11.25 10.5 11.25C9.83696 11.25 9.20107 10.9866 8.73223 10.5178C8.26339 10.0489 8 9.41304 8 8.75V7.5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M18 7.5V8.75C18 9.41304 17.7366 10.0489 17.2678 10.5178C16.7989 10.9866 16.163 11.25 15.5 11.25C14.837 11.25 14.2011 10.9866 13.7322 10.5178C13.2634 10.0489 13 9.41304 13 8.75V7.5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
              </g>
            </svg>
          </a>
        </div>
      </div>
    </div>
    <button class="o-modal__overlay" data-modal-close></button>
    </div>
  `;
    
  return template;
}

export class CustomiserCartSuccess extends HTMLElement {

  private modal;
  private addAnotherBtn;
  private closeBtns;

  constructor() {
    super();

    const shadowRoot = this.attachShadow({ mode: 'open' });
    const template = getCartSuccess();
    shadowRoot.appendChild(template.content.cloneNode(true));

    this.modal = this.shadowRoot?.querySelector('[data-cart-success]');
    this.addAnotherBtn = this.shadowRoot?.querySelector('[data-add-another]');
    this.closeBtns = this.shadowRoot?.querySelectorAll('[data-modal-close]');

    this.addAnotherBtn?.addEventListener('click', () => this.dispatchEvent(new CustomEvent('add_another', { bubbles: true })));

    this.closeBtns?.forEach(btn => {
      btn.addEventListener('click', () => this.closeCustomiser());
    });
  }

  public openCartSuccess() {
    this.modal?.classList.add('is-open');
    this.modal?.classList.remove('is-adding');
  }

  public openCartAdding(text: string, url: string) {
    this.modal?.classList.add('is-open');

    const continueShoppingBtn = this.modal?.querySelector('[data-continue-shopping]') as HTMLAnchorElement;
    const preloaderText = this.modal?.querySelector('.preloader-text');
    if (preloaderText) preloaderText.innerText = text;
    if (continueShoppingBtn) continueShoppingBtn.setAttribute('href', url);
  }

  public closeCartSuccess() {
    this.modal?.classList.remove('is-open');
    this.modal?.classList.add('is-adding');
  }

  public closeCustomiser() {
    this.closeCartSuccess();

    setTimeout(() => {
      this.dispatchEvent(new CustomEvent('close_customiser', { bubbles: true }));
    }, 1000);
  }
}

if(!customElements.get('customiser-cart-success')) {
  customElements.define('customiser-cart-success', CustomiserCartSuccess);
}